import { EntityId, Nullable } from '@Models';
import {
  RequestAction,
  RequestDataSuccess,
  RequestFailure,
} from '@Repository/RequestAction';
import { ICrudEntityAction } from '@Redux/ICrudEntityAction';
import { createAsyncThunk } from '@reduxjs/toolkit';

export abstract class IEntitiesAction<
  T extends EntityId<string | number>,
  Q extends RequestDataSuccess<Array<T>>,
> extends ICrudEntityAction<T[]> {
  public fetchData = createAsyncThunk(
    `${this.constructor.name}/getAll`,
    async (_, thunkAPI) => {
      thunkAPI.dispatch(this.areLoading(true));

      const cachedItems = await this.getCachedItems();
      if (cachedItems != null)
        thunkAPI.dispatch(this.cacheDataSuccess(cachedItems));

      const response = await this.getItems();

      if (response instanceof RequestFailure) {
        const failure = response as RequestFailure;

        thunkAPI.dispatch(this.haveError(failure.error.message));
        thunkAPI.dispatch(this.areLoading(false));
        return;
      }

      const success = response as Q;
      thunkAPI.dispatch(this.fetchDataSuccess(success.payload));
      thunkAPI.dispatch(this.areLoading(false));
    },
  );

  protected abstract getCachedItems(): Promise<Nullable<Array<T>>>;

  protected abstract getItems(): Promise<RequestAction>;
}
